export interface IVersion {
    major: number;
    minor: number;
    patch: number;
}

export interface IVersionEx {
    version: IVersion;
    compatibleWith(version: IVersion): boolean;
    toString(): string;
}

// Версия для проверки совместимости плагинов.
// Обязательно выставлять мажорную версию.
// Так как только она сейчас участвует в проверке
export const imVersion: IVersion = { major: 1, minor: 0, patch: 0 };
